// =============================================================================
// DETAILER ICONS — source unique des icônes MUI par type de detailer (#55).
// Utilisées par les boutons « + » des blocs vêtements (RabbitBlockNode) et
// dans le header des blocs detailer.
// =============================================================================

import PaletteIcon from '@mui/icons-material/Palette';
import TextureIcon from '@mui/icons-material/Texture';
import PatternIcon from '@mui/icons-material/Pattern';
import type { DetailerType } from '../types';

// Toutes les icônes MUI partagent le même type de composant (SvgIcon).
export const DETAILER_ICONS: Record<DetailerType, typeof PaletteIcon> = {
  color: PaletteIcon,
  texture: TextureIcon,
  pattern: PatternIcon,
};
